"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_SIA_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetSia,
    skipImportingInCMS: false,
}, {
    elencoPolizze: {
        __mfeName__: "elencoPolizze",
        devClientPort: 6020,
        devServerPort: 6120,
    },
    dettaglioPolizza: {
        __mfeName__: "dettaglioPolizza",
        devClientPort: 6021,
        devServerPort: 6121,
    },
    tpdRecuperoConsensoPrivacyWidget: {
        __mfeName__: "tpdRecuperoConsensoPrivacyWidget",
        devClientPort: 6337,
        devServerPort: 6437,
    },
    elencoPreventivi: {
        __mfeName__: "elencoPreventivi",
        devClientPort: 6022,
        devServerPort: 6122,
    },
    tpdLaTuaAgenzia: {
        __mfeName__: "tpdLaTuaAgenzia",
        devClientPort: 6032,
        devServerPort: 6132,
    },
    tpdLeTuePolizzeWidget: {
        __mfeName__: "tpdLeTuePolizzeWidget",
        devClientPort: 6037,
        devServerPort: 6137,
    },
    tpdPreventiviWidget: {
        __mfeName__: "tpdPreventiviWidget",
        devClientPort: 6019,
        devServerPort: 6119,
        mfePriority: 1900,
    },
    tpdPreventivatorePrevidenzaWidget: {
        __mfeName__: "tpdPreventivatorePrevidenzaWidget",
        devClientPort: 6343,
        devServerPort: 6443
    },
});
exports.WIDGET_SIA_REMOTES_SETTINGS = settings;
